import React, { Component } from 'react';
import { connect } from 'react-redux';
import GeckoPagination from 'services/gecko-pagination';
import GeckoLocation from 'services/gecko-location';
import {
  GeckoCardTable,
  GeckoModalService,
  GeckoModal,
  GECKO_CONSTS,
  GeckoToastService,
} from 'ui';
import EditModal from './EditModal.jsx';
import GeckoDate from 'services/gecko-date';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import {
  stringToHexColour,
  isValidHex,
  getContrastHexColour,
} from 'utilities/colours';

import './tags.scss';
import GeckoFeatures from 'services/gecko-features/index.js';

export class Tags extends Component {
  state = {
    tagEditting: {},
    tagValues: {},
  };

  cols = [
    {
      key: 'colour',
      name: 'Colour',
      type: GECKO_CONSTS.TABLE_CELL_TYPE_CUSTOM,
      width: '1%',
      render: (colour, row) => {
        const aiStyle = {
          background: 'linear-gradient(180deg, #3460AD 0%, #CF66D1 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          paddingRight: '5px',
          fontSize: '12px',
          textAlign: 'center',
        };
        const dotColour = {
          color: colour,
        };

        const containerStyle = {
          display: 'inline-block',
          paddingRight: '10px',
        };
        return !row.ai_generated ? (
          <span className="conversation-tag">
            <i className="tag-icon fas fa-circle" style={dotColour}></i>
            {colour}
          </span>
        ) : (
          <span className="conversation-tag">
            <i className="far fa-sparkles" style={aiStyle}></i>
            <span style={containerStyle}>AI Tag</span>
          </span>
        );
      },
    },
    {
      key: 'name',
      name: 'Tag Name',
    },
    {
      key: 'createdAt',
      name: 'Created On',
      render: (date) => new GeckoDate(date).LONG,
    },
    GeckoFeatures.can('ai-insights') && {
      key: 'allow_for_ai',
      name: 'Use with AI Summary',
      render: (use) => (use ? 'Yes' : '-'),
      width: '1%',
    },
    {
      type: GECKO_CONSTS.TABLE_CELL_TYPE_DROPDOWN,
      width: '1%',
      items: [
        {
          name: 'Edit',
          handler: (tag) => this.editTag(tag),
        },
        {
          name: 'Remove',
          handler: (tag) => this.removeTag(tag),
        },
      ],
    },
  ].filter(Boolean);

  headerBtns = [
    {
      name: 'Add New',
      icon: 'far fa-plus',
      type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
      handler: () => this.editTag({ colour: '#172B4D' }),
    },
  ];

  editTag(tag) {
    new GeckoModalService()
      .open(() => <EditModal tag={tag} />)
      .then((result) => {
        if (!result) {
          return null;
        }
        if (!result.colour || !isValidHex(result.colour)) {
          result.colour = stringToHexColour(result.name);
        }
        if (tag.id) {
          return GeckoRequest.post(`/models/tags/${tag.id}`, result);
        } else {
          return GeckoRequest.post(`/models/tags`, result);
        }
      })
      .then((newTag) => {
        if (newTag === null) {
          return;
        }
        new GeckoToastService().success(
          tag.id ? 'Tag successfully updated' : 'Tag successfully created'
        );
      })
      .catch(renderError);
  }

  removeTag(tag) {
    return GeckoRequest.get(`/tags/conversation-tag/${tag.id}/count`)
      .then((response) => {
        const count = response.conversationCount;
        return new GeckoModalService().open(() => {
          return (
            <GeckoModal
              name="Remove Tag"
              children={
                <p>{`Are you sure you want to remove this Tag?\nThis tag will be removed from ${count} ${
                  count == 1 ? 'conversation' : 'conversations'
                }`}</p>
              }
              btns={[
                {
                  name: 'Cancel',
                  secondary: true,
                  icon: 'fa fa-times',
                  handler: () => {
                    return new GeckoModalService().close();
                  },
                },
                {
                  type: GECKO_CONSTS.BTN_TYPE_DANGER,
                  name: 'Remove Tag',
                  handler: () => {
                    return GeckoRequest.delete(`/tags/${tag.id}`)
                      .then(() => {
                        new GeckoModalService().close();
                        new GeckoToastService().success('Tag removed');
                      })
                      .catch(renderError);
                  },
                },
              ]}
            />
          );
        });
      })
      .catch(renderError);
  }

  onSearch(term) {
    GeckoLocation.goTo(
      '/settings/tags',
      Object.assign({}, this.props.params, { search: term })
    );
  }

  render() {
    const alertDetails = this.props.tags?.length
      ? { alert: 'There are no results to show.' }
      : {
          alert: 'You have not created any Tags yet.',
          linkHandler: () => this.editTag({ colour: '#172B4D' }),
        };
    const [tags, pagination] = GeckoPagination.paginate({
      page: this.props.params.page,
      order_by: 'name',
      searchTerm: this.props.params.search,
      searchKey: 'name',
    })(this.props.tags);
    return (
      <div className="Tags content-margin">
        <GeckoCardTable
          name="Tags"
          headerBtns={this.headerBtns}
          rows={tags}
          cols={this.cols}
          rowHandler={this.editTag.bind(this)}
          pagination={pagination}
          newLinkHandler={alertDetails.linkHandler}
          alert={alertDetails.alert}
          onSearch={this.onSearch.bind(this)}
          headerProps={{ searchPlaceholder: 'Search tags' }}
        ></GeckoCardTable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tags: state.tags.filter((tag) => !tag.ai_generated),
    params: state.location.params,
  };
};

export default connect(mapStateToProps)(Tags);
